import { render, staticRenderFns } from "./SharingFee.vue?vue&type=template&id=30cdf3f6&scoped=true"
import script from "./SharingFee.vue?vue&type=script&lang=js"
export * from "./SharingFee.vue?vue&type=script&lang=js"
import style0 from "./SharingFee.vue?vue&type=style&index=0&id=30cdf3f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cdf3f6",
  null
  
)

export default component.exports